/**
 * @generated SignedSource<<dc667416605c45f4e9fb29c8594b350e>>
 * @relayHash 0f9f8a79d54b7bf69bd4ddc3c65a57b2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3c21a1f19ee00080fdbd0fc4853475b9e944bd3f18e9b98d9d5314b5ca267906

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraUpdateVersionStartDateInput = {
  id: string;
  startDate?: AGG$DateTime | null | undefined;
};
export type versionDates_updateVersionStartDateMutation$variables = {
  input: JiraUpdateVersionStartDateInput;
};
export type versionDates_updateVersionStartDateMutation$data = {
  readonly jira: {
    readonly updateVersionStartDate: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly errorType: string | null | undefined;
          readonly statusCode: number | null | undefined;
        } | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
      readonly version: {
        readonly startDate: AGG$DateTime | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type versionDates_updateVersionStartDateMutation = {
  response: versionDates_updateVersionStartDateMutation$data;
  variables: versionDates_updateVersionStartDateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v4 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v5 = {
  "kind": "ScalarField",
  "name": "startDate"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "versionDates_updateVersionStartDateMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateVersionPayload",
            "kind": "LinkedField",
            "name": "updateVersionStartDate",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/)
                    ]
                  }
                ]
              },
              {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "versionDates_updateVersionStartDateMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateVersionPayload",
            "kind": "LinkedField",
            "name": "updateVersionStartDate",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v3/*: any*/),
                      (v4/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v6/*: any*/)
                        ],
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "3c21a1f19ee00080fdbd0fc4853475b9e944bd3f18e9b98d9d5314b5ca267906",
    "metadata": {},
    "name": "versionDates_updateVersionStartDateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "9222866e01fe4d9b93a39fe2c827a3b0";

export default node;
